import { render } from "./RoleDetailEdit.vue?vue&type=template&id=39eb2350&scoped=true"
import script from "./RoleDetailEdit.vue?vue&type=script&lang=js"
export * from "./RoleDetailEdit.vue?vue&type=script&lang=js"

import "./RoleDetailEdit.vue?vue&type=style&index=0&id=39eb2350&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eb2350"]])

export default __exports__